import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bluebox',
  templateUrl: './bluebox.component.html',
  styleUrls: ['./bluebox.component.scss']
})
export class BlueboxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
